import { Component, OnInit, ChangeDetectorRef, Input } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Router } from "@angular/router";

@Component({
  selector: "app-login-or-register-dialog",
  templateUrl: "./login-or-register-dialog.component.html",
  styleUrls: ["./login-or-register-dialog.component.css"],
})
export class LoginOrRegisterDialogComponent implements OnInit {
  @Input() title: string;
  @Input() message: string;
  @Input() btnOkText: string;
  @Input() btnCancelText: string;

  constructor(
    private activeModal: NgbActiveModal,
    private cdr: ChangeDetectorRef,
    private route: Router
  ) {}

  ngOnInit() {}

  public decline() {
    this.activeModal.close(false);
  }

  public login() {
    this.activeModal.close(true);
    this.route.navigate(["/WebPanel/account-login"]);
  }

  public register() {
    this.activeModal.close(true);
    this.route.navigate(["/WebPanel/account-register"]);
  }
}
